import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import {
  DOWNLOAD_BOOKING_V2,
  DOWNLOAD_BOOKING_V2_EMPTY,
  DOWNLOAD_REFERRALS,
  GET_BOOKING_LIST_V2,
  GET_BOOKING_LIST_V2_EMPTY,
  GET_REFERRAL,
  GET_REFERRAL_EMPTY,
} from '../../../../../../store/actions';
import { Loader } from '../../../../../Common';
import BreadcrumbTrail from '../../../../../Common/BreadcrumbTrail';
import { Constant } from '../../../../../Helpers/constant';
import Filter from './Components/Filters/Filter';
import Table from './Components/Tables/Table';
import moment from 'moment';

const ClientDynamicBooking = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  // Parse URL query parameters
  const { page = 1, perPageLimit = Constant.TABLE_PAGE_SIZE } = queryString.parse(location.search);

  const [bookingType, setBookingType] = useState(['DYNAMIC_COUPON']);
  const [loading, setLoading] = useState(false);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(page);
  const [rowsPerPage, setRowsPerPage] = useState(Number(perPageLimit));

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Bookings
  const { bookings, bookingsLoading } = useSelector((state: any) => ({
    bookings: state?.BookingsV2?.data,
    bookingsLoading: state?.BookingsV2?.loading,
  }));

  // Click Download Dump
  const { downloadDump, downloadDumpLoading } = useSelector((state: any) => ({
    downloadDump: state?.DownloadDumpV2?.data,
    downloadDumpLoading: state?.DownloadDumpV2?.loading,
  }));

  useEffect(() => {
    const { page, perPageLimit } = queryString.parse(location.search);
    setCurrentPageNumber(Number(page || 1)); // Default to 1-based page
    setRowsPerPage(Number(perPageLimit || Constant.TABLE_PAGE_SIZE));
  }, [location.search]);

  useEffect(() => {
    dispatch({
      type: GET_BOOKING_LIST_V2,
      payload: {
        data: {
          page: currentPageNumber,
          pageSize: rowsPerPage,
          booking_type: bookingType,
          sort_by: 'updated_at',
          ...currentlyAppliedFilters,
        },
      },
    });
  }, [currentlyAppliedFilters, currentPageNumber, rowsPerPage, dispatch]);

  useEffect(() => {
    if (downloadDump !== null) {
      dispatch({
        type: DOWNLOAD_BOOKING_V2_EMPTY,
      });
    }
  }, [downloadDump]);

  useEffect(() => {
    if (bookingsLoading || downloadDumpLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [bookingsLoading, downloadDumpLoading]);

  const filterSubmitHandler = filters => {
    setCurrentlyAppliedFilters(filters);
    dispatch({
      type: GET_BOOKING_LIST_V2_EMPTY,
    });
    updateURLParams({ page: 1 });
  };

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);
    const updatedParams = {
      page: currentPageNumber, // Default to current page
      perPageLimit: rowsPerPage, // Default to current rowsPerPage
      ...currentParams, // Merge existing query parameters
      ...newParams, // Override with new parameters
    };

    const newUrl = queryString.stringify(updatedParams);

    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    updateURLParams({ page: pageNumber });
  };

  const handleRowsPerPageChange = (newRowsPerPage, page) => {
    updateURLParams({ page: 1, perPageLimit: newRowsPerPage });
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  /* ---------------------------- DOWNLOAD DUMP HANDLER ---------------------------- */
  const downloadDumpHandler = () => {
    const filters = { ...currentlyAppliedFilters };

    if (!filters?.created_at_start) {
      filters.created_at_start = moment().subtract(29, 'days').format('YYYY-MM-DD');
    }
    if (!filters?.created_at_end) {
      filters.created_at_end = moment().format('YYYY-MM-DD');
    }

    dispatch({
      type: DOWNLOAD_BOOKING_V2,
      payload: {
        data: {
          booking_type: bookingType,
          ...filters,
          ...currentlyAppliedFilters,
        },
      },
    });
  };

  return (
    <>
      {loading && <Loader />}

      <div className="page-content">
        <Container fluid className="position-relative">
          {/*  ----------------------------  UI'S ---------------------------- */}{' '}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0' }}>
            <BreadcrumbTrail title="Dynamic Booking" navigationby={breadcrumNavigationHandler} navigation={[`Dashboard`, `Dynamic Booking`]} />
            <Filter filterHandler={filterSubmitHandler} />
          </div>
          <Table
            data={bookings?.result}
            totalCount={bookings?.total_count}
            pageNumber={currentPageNumber}
            limit={rowsPerPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            handlePageChange={paginationHandler}
            dumpDownload={downloadDumpHandler}
          />
        </Container>
      </div>
    </>
  );
};

export default ClientDynamicBooking;
